import { LaptopOutlined } from "@ant-design/icons";
import { CrudOp, externalConfiguratorAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ExternalConfiguratorView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { brand }) => {
  const authHelper = authHelperCreator(externalConfiguratorAuthScope);
  return brand != null && authHelper.evaluate(CrudOp.READ, brand);
};

export const externalConfiguratorViewKey = "configuration_modular_externalConfigurator/externalconfigurator-view/:projectId/:subprojectId/:brand";
export const externalConfiguratorViewModule: ViewModule = {
  viewKey: externalConfiguratorViewKey,
  viewEl: <ExternalConfiguratorView/>,
  displayNameI18nKey: "tenant:externalConfigurator.viewName",
  menuIconEl: <LaptopOutlined/>,
  isAuthorized,
  translations,
};
